"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryKVStore = void 0;
const base_1 = require("./base");
class MemoryKVStoreProvider {
    constructor() {
        this.store = {};
    }
    get() {
        return Promise.resolve(this.store);
    }
    set(items) {
        this.store = Object.assign(Object.assign({}, this.store), items);
        return Promise.resolve();
    }
}
class MemoryKVStore extends base_1.BaseKVStore {
    constructor(prefix) {
        super(new MemoryKVStoreProvider(), prefix);
    }
}
exports.MemoryKVStore = MemoryKVStore;
//# sourceMappingURL=memory.js.map